import React from 'react';
import { useTranslation } from "react-i18next";

const Spinner = (props) => {

  const { t, i18n } = useTranslation();

  return (
    <div className={`minilagerloader ${props.extra? props.extra :""}`}>
      <svg width="121" height="103" viewBox="0 0 121 103" fill="transparent" xmlns="http://www.w3.org/2000/svg">
        <g id="Group 41">
        <g id="Frame 6">
        <rect width="121" height="103" />
        <g id="Layer 2">
        <g id="Layer 1">
        <path className="box2" id="Vector 2" d="M47.1127 32.2145L31.0752 27.101L43.1033 17.6607L59.0005 22.7793L47.1127 32.2145Z" fill="#3F3D2C"/>
        <path className="box1" id="Vector 1" d="M60.4283 21.695L44.5361 16.4353L56.5643 7L72.3161 12.1135L60.4283 21.695Z" fill="#3F3D2C"/>
        <path className="box6" id="Vector 6" d="M48.9014 32.7894L60.7892 23.2835L76.7565 28.5382L64.9389 38.0492L48.9014 32.7894Z" fill="#3F3D2C"/>
        <path className="box5" id="Vector 5" d="M62.3633 22.275L74.3212 12.6178L90.2134 18.0238L78.3306 27.6053L62.3633 22.275Z" fill="#3F3D2C"/>
        <path className="box3" id="Vector 3" d="M29.7168 44.968L30.1478 28.2508L46.5411 33.7274L45.8946 50.2227L29.7168 44.968Z" fill="#E6F0CB"/>
        <path className="box7" id="Vector 7" d="M47.4736 50.5858L47.8996 34.2317L64.298 39.2393L63.6515 55.8455L47.4736 50.5858Z" fill="#3F3D2C"/>
        <path className="box10" id="Vector 10" d="M65.6556 39.2393L65.2998 55.2656L77.2578 45.8304L77.7589 29.9099L65.6556 39.2393Z" fill="#88A476"/>
        <path className="box12" id="Vector 12" d="M78.4877 46.8908L78.1318 62.9171L90.9998 52.8421V36.386L78.4877 46.8908Z" fill="#88A476"/>
        <path className="box9" id="Vector 9" d="M79.1877 28.6139L78.6865 45.0386L90.6445 35.3109L91.0003 19.3198L79.1877 28.6139Z" fill="#3F3D2C"/>
        <path className="box11" id="Vector 11" d="M65.2999 57.4996L64.7285 73.4201L76.7566 64.131L77.1125 48.1349L65.2999 57.4996Z" fill="#3F3D2C"/>
        <path className="box8" id="Vector 8" d="M47.4728 52.3155L46.8965 68.594L63.0793 74L63.5805 57.5753L47.4728 52.3155Z" fill="#45812B"/>
        <path className="box4" id="Vector 4" d="M29 63.1577L29.7167 46.6221L45.8945 51.7356L45.3933 68.3771L29 63.1577Z" fill="#3F3D2C"/>
        </g>
        </g>
        <g >
            <text className="text1 textloading" id="L" fill="black" xmlSpace="preserve"><tspan x="25" y="97.8636">{`${t("L")}`}</tspan></text>
            <text className="text3 textloading" id="o" fill="black" xmlSpace="preserve"><tspan x="35" y="97.8636">{`${t("o")}`}</tspan></text>
            <text className="text2 textloading" id="a" fill="black" xmlSpace="preserve"><tspan x="45" y="97.8636">{`${t("a")}`} </tspan></text>
            <text className="text7 textloading" id="d" fill="black" xmlSpace="preserve"><tspan x="55" y="97.8636">{`${t("d")}`}</tspan></text>
            <text className="text4 textloading" id="i" fill="black" xmlSpace="preserve"><tspan x="65" y="97.8636">{`${t("i")}`} </tspan></text>
            <text className="text5 textloading" id="n" fill="black" xmlSpace="preserve"><tspan x="75" y="97.8636">{`${t("n")}`} </tspan></text>
            <text className="text6 textloading" id="g" fill="black" xmlSpace="preserve"><tspan x="85" y="97.8636">{`${t("g")}`}</tspan></text>
           
        </g>
        
        </g>
        </g>
        </svg>
        
        </div>
  )
}

export default Spinner